import React from 'react';
import Header from './components/Header';
import Details from './components/Details';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Details />
      <Footer />
    </div>
  );
}

export default App;
